import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { v4 as uuidv4 } from "uuid";

import { genericFilter, formatDateTime } from "../../utils/utils";

const STORE_NAME = "ORDERS_STORE";

const INIT_STATE = {
  orders: [],
  filteredOrders: [],
  events: [],
  selectedFilters: [],
};

const store = (set) => ({
  ...INIT_STATE,
  setOrders: async (orders) => set(() => ({ orders })),
  setOcurrences: async (ocurrences) => set(() => ({ ocurrences })),
  setEvents: async (events) => set(() => ({ events })),
  //setSelectedFilters: async (selectedFilters) => set(() => ({ selectedFilters })),
  filterOrders() {
    set((state) => {
      let _SELECTED_FILTERS = state.selectedFilters
        .map((e) => {
          return { [e.prop]: e.value };
        })
        .reduce(function (acc, x) {
          for (var key in x) acc[key] = x[key];
          return acc;
        }, {});

      let _ALL_FILTERS = state.selectedFilters
        .map((e) => {
          return { [e.prop]: e.value };
        })
        .reduce(function (acc, x) {
          for (var key in x) acc[key] = x[key];
          return acc;
        }, {});

      let ALL_ORDERS = [];
      
      if (!!_SELECTED_FILTERS["fechaPromesa"]) {
        delete _SELECTED_FILTERS.fechaPromesa;
      }

      if (!!_SELECTED_FILTERS["fechaFinPromesa"]) {
        delete _SELECTED_FILTERS.fechaFinPromesa;
      }

      const _filteredOrders = genericFilter(
        [...state.orders],
        _SELECTED_FILTERS
      );

      let filtersWithDate = null;

      if (!!_ALL_FILTERS["fechaPromesa"] || !!_ALL_FILTERS["fechaFinPromesa"]) {
        let start = _ALL_FILTERS["fechaPromesa"]
          ? new Date(_ALL_FILTERS["fechaPromesa"])
          : new Date();
        let end = _ALL_FILTERS["fechaFinPromesa"]
          ? new Date(_ALL_FILTERS["fechaFinPromesa"])
          : new Date();

        filtersWithDate = _filteredOrders.filter((order) => {
          let date = new Date(order.fechaPromesa);
          return date >= start && date <= end;
        });
      }

      return {
        filteredOrders:
          filtersWithDate
            ? (filtersWithDate.length > 0 ? filtersWithDate : -1)
            : _filteredOrders.length > 0
            ? _filteredOrders
            : -1,
      };
    });
  },
  addSelectedFilter: (filter) => {
    set((state) => {
      const INDEX_TO_REPLACE = state.selectedFilters.findIndex(
        (f) => f.prop === filter.prop
      );

      if (INDEX_TO_REPLACE >= 0) {
        return {
          selectedFilters: [
            ...state.selectedFilters.filter((f) => f.prop !== filter.prop),
            filter,
          ],
        };
      } else {
        return {
          selectedFilters: [...state.selectedFilters, filter],
        };
      }
    });
  },
  removeSelectedFilter: (filter) => {
    set((state) => {
      const _DROPED_FILTERS = state.selectedFilters.filter(
        (e) => e.prop !== filter.prop
      );

      return {
        selectedFilters: _DROPED_FILTERS,
      };
    });
  },
  filterOcurrences() {
    set((state) => {
      let _SELECTED_FILTERS = state.selectedFilters
        .map((e) => {
          return { [e.prop]: e.value };
        })
        .reduce(function (acc, x) {
          for (var key in x) acc[key] = x[key];
          return acc;
        }, {});

      let _ALL_FILTERS = state.selectedFilters
        .map((e) => {
          return { [e.prop]: e.value };
        })
        .reduce(function (acc, x) {
          for (var key in x) acc[key] = x[key];
          return acc;
        }, {});

      let ALL_ORDERS = [];
      
      if (!!_SELECTED_FILTERS["fechaPromesa"]) {
        delete _SELECTED_FILTERS.fechaPromesa;
      }

      if (!!_SELECTED_FILTERS["fechaFinPromesa"]) {
        delete _SELECTED_FILTERS.fechaFinPromesa;
      }

      const _filteredOrders = genericFilter(
        [...state.ocurrences],
        _SELECTED_FILTERS
      );

      let filtersWithDate = null;

      if (!!_ALL_FILTERS["fechaPromesa"] || !!_ALL_FILTERS["fechaFinPromesa"]) {
        let start = _ALL_FILTERS["fechaPromesa"]
          ? new Date(_ALL_FILTERS["fechaPromesa"])
          : new Date();
        let end = _ALL_FILTERS["fechaFinPromesa"]
          ? new Date(_ALL_FILTERS["fechaFinPromesa"])
          : new Date();

        filtersWithDate = _filteredOrders.filter((order) => {
          let date = new Date(order.fechaPromesa);
          return date >= start && date <= end;
        });
      }

      return {
        filteredOcurrences:
          filtersWithDate
            ? (filtersWithDate.length > 0 ? filtersWithDate : -1)
            : _filteredOrders.length > 0
            ? _filteredOrders
            : -1,
      };
    });
  },
  resetFilters: async () =>
    set(() => ({ selectedFilters: [], filteredOrders: [], filteredOcurrences: [] })),
});

export const ordersStore = create(
  devtools(store, { name: STORE_NAME })
  // devtools(persist(store, { name: STORE_NAME }), { name: STORE_NAME })
);
